import { Component, OnInit, Input} from '@angular/core';
import { fadeInUpAnimation } from 'src/@fury/animations/fade-in-up.animation';
import { fadeInRightAnimation } from 'src/@fury/animations/fade-in-right.animation';
import { scaleInAnimation } from 'src/@fury/animations/scale-in.animation';
import { ApiService } from 'src/app/services/api.service';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpErrorResponse, HttpResponse } from '@angular/common/http';

@Component({
  selector: 'fury-service-agreement-details',
  templateUrl: './service-agreement-details.component.html',
  styleUrls: ['./service-agreement-details.component.scss'],
  animations: [fadeInUpAnimation, fadeInRightAnimation, scaleInAnimation]
})
export class ServiceAgreementDetailsComponent implements OnInit {

  serviceAgreementId: any;
  agreementDetails: any;
  loader !: boolean;
  constructor(
    private apiService: ApiService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    ) {
      this.serviceAgreementId = this.activatedRoute.snapshot.params["id"];
  if(this.serviceAgreementId){
    this.getServiceAgreementDetails();
  } 
     }

  ngOnInit(): void { }
     getServiceAgreementDetails(){
      this.loader = true;
      this.apiService.get(`admin/service-agreement-type/get-service-agreement-type/${this.serviceAgreementId}`).subscribe((res : HttpResponse<any>) => {
        if(res.status === 200){
          this.loader = false;
          this.agreementDetails = res.body?.serviceAgreementType;
        }
      }, err =>{
        this.loader = false;
      })
     }

}
